export const CheckIcon = ({ className = '' }: { className?: string }) => {
  return (
    <svg width="15" height="10" viewBox="0 0 15 10" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M14.1087 0.3914C14.3527 0.635475 14.3527 1.03121 14.1087 1.27528L6.95383 8.43009C6.05891 9.32509 4.60791 9.32509 3.71296 8.43009L0.724804 5.44192C0.480729 5.19784 0.480729 4.80217 0.724804 4.55809C0.968879 4.31401 1.36461 4.31401 1.60869 4.55809L4.59685 7.54626C5.00364 7.95301 5.66316 7.95301 6.07 7.54626L13.2248 0.3914C13.4689 0.147325 13.8646 0.147325 14.1087 0.3914Z" fill="currentColor" />
    </svg>
  )
}
